"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDisabledChipStylesEnterprise = exports.chipVariants = exports.selectedChipEnterprise = exports.defaultChipEnterprise = void 0;
var chips = __importStar(require("../../../shared/chips"));
exports.defaultChipEnterprise = {
    props: { variant: 'default' },
    style: function (_a) {
        var _b, _c, _d;
        var theme = _a.theme;
        var defaultChipStyles = (_d = (_c = (_b = chips.defaultChip).style) === null || _c === void 0 ? void 0 : _c.call(_b, { theme: theme })) !== null && _d !== void 0 ? _d : {};
        var enterpriseOverrides = {
            color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"),
        };
        return __assign(__assign({}, defaultChipStyles), enterpriseOverrides);
    },
};
exports.selectedChipEnterprise = {
    props: { variant: 'selected' },
    style: function (_a) {
        var _b, _c, _d;
        var theme = _a.theme;
        var selectedChipStyles = (_d = (_c = (_b = chips.selectedChip).style) === null || _c === void 0 ? void 0 : _c.call(_b, { theme: theme })) !== null && _d !== void 0 ? _d : {};
        var enterpriseOverrides = {
            color: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")"),
            backgroundColor: "var(--secondary-300, ".concat(theme.palette.secondary.light, ")"),
            // we need to override selected disabled chip styles
            '&.Mui-disabled': {
                backgroundColor: "var(--neutrals-100, ".concat(theme.palette.backgrounds.neutral, ")"),
            },
        };
        return __assign(__assign({}, selectedChipStyles), enterpriseOverrides);
    },
};
exports.chipVariants = [
    exports.defaultChipEnterprise,
    chips.inputChip,
    exports.selectedChipEnterprise,
    chips.errorChip,
    chips.pendingChip,
];
var generateDisabledChipStylesEnterprise = function (theme) { return ({
    '&.Mui-disabled': {
        opacity: 1,
        color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
        borderColor: "var(--neutrals-700, ".concat(theme.palette.neutrals.disabled, ")"),
    },
}); };
exports.generateDisabledChipStylesEnterprise = generateDisabledChipStylesEnterprise;
